import angular from 'angular';
import { filterMessageComponent } from './filterMessageComponent';
import { FilterMessageService } from './FilterMessageService';

angular
	.module('sh.filterMessage', [])
	.component('shFilterMessage', filterMessageComponent())
	.service('FilterMessage', FilterMessageService);
